exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Search-module__input___qSTe3{border:1px solid #ececec;padding:.5rem .75rem;font-size:14px}", ""]);

// exports
exports.locals = {
	"input": "Search-module__input___qSTe3"
};